import React from 'react'

import { BrowserRouter, useLocation, useNavigate, useParams } from 'react-router-dom'
import { StaticRouter } from 'react-router-dom/server'

import PropTypes from 'prop-types'

export { useLocation, useNavigate, useParams }

function ContextBasedRouter({ children, basename = '/', initialPathname = '' }) {
  if (typeof window === 'undefined') {
    return (
      <StaticRouter basename={basename} location={initialPathname}>
        {children}
      </StaticRouter>
    )
  }

  return (
    <BrowserRouter basename={basename}>
      {children}
    </BrowserRouter>
  )
}

ContextBasedRouter.propTypes = {
  children: PropTypes.node.isRequired,
  basename: PropTypes.string,
  initialPathname: PropTypes.string,
}

export default ContextBasedRouter
